import ApiService from "@/core/services/api.service";
// import JwtService from "@/core/services/jwt.service";

//Actions
export const FETCH_ASSIGNMENT_NOTIFICATIONS = "fetchAssignmentNotifications";
export const SEND_ASSIGNMENT_NOTIFICATIONS = "sendAssignmentNotifications";

//Mutations
export const SET_ERROR = "setError";
export const SET_LOADING = "setLoadingAssignmentNotifications";

const state = {
  errors: [],
  isLoadingAssignmentNotifications: false
};

const getters = {
  isLoadingAssignmentNotifications() {
    return state.isLoadingAssignmentNotifications;
  }
};

const actions = {
  [FETCH_ASSIGNMENT_NOTIFICATIONS](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("assignment-notifications" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [SEND_ASSIGNMENT_NOTIFICATIONS](context, params) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.post("assignments-notifications-send", params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.isLoadingAssignmentNotifications = false;
    if (Array.isArray(errors)) {
      state.errors = errors;
    } else {
      state.errors = [errors];
    }
  },
  [SET_LOADING](state, value) {
    state.isLoadingAssignmentNotifications = value;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
